import { Typography, Box, Modal, Card, CardContent, CardMedia } from '@mui/material'
import React from 'react'
import "react-glidejs/dist/index.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import dish1 from '../assets/dish1.png';
import dish2 from '../assets/dish2.png';
import dish3 from '../assets/dish3.png';
import dish4 from '../assets/dish4.png';
import dish5 from '../assets/dish5.png';
import dish6 from '../assets/dish6.png';
import dish7 from '../assets/dish7.png';
import dish8 from '../assets/dish8.png';
import dessert1 from '../assets/dessert1.png';
import dessert2 from '../assets/dessert2.png';
import dessert3 from '../assets/dessert3.png';
import dessert4 from '../assets/dessert4.png';
import dessert5 from '../assets/dessert5.png';
import dessert6 from '../assets/dessert6.png';
import dessert7 from '../assets/dessert7.png';
import dessert8 from '../assets/dessert8.png';
import boisson1 from '../assets/boisson1.png';
import boisson2 from '../assets/boisson2.png';
import boisson3 from '../assets/boisson3.png';
import boisson4 from '../assets/boisson4.png';
import boisson5 from '../assets/boisson5.png';
import boisson6 from '../assets/boisson6.png';
import boisson7 from '../assets/boisson7.png';
import boisson8 from '../assets/boisson8.png';
function useMobileDetect() {
    const [isMobile, setIsMobile] = React.useState(false);
    SwiperCore.use([Navigation, Autoplay]);

    React.useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 768);
        }

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    return isMobile;
}
function Menus() {
    const isMobile = useMobileDetect();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const dishes = [
        { image: dish1, description: "라면", price: "₩5000" },
        { image: dish2, description: "김치", price: "₩6000" },
        { image: dish3, description: "김밥", price: "₩8000" },
        { image: dish4, description: "비빔밥", price: "₩8000" },
        { image: dish5, description: "불고기", price: "₩9000" },
        { image: dish6, description: "떡볶이", price: "₩10000" },
        { image: dish7, description: "찌개", price: "₩11000" },
        { image: dish8, description: "라면", price: "₩12000" },
    ]
    const desserts = [
        { image: dessert1, description: "배숙", price: "₩5000" },
        { image: dessert2, description: "빙수", price: "₩6000" },
        { image: dessert3, description: "밀크셰이크", price: "₩7000" },
        { image: dessert4, description: "와플", price: "₩4000" },
        { image: dessert5, description: "푸딩", price: "₩3000" },
        { image: dessert6, description: "딸기 유리잔", price: "₩8000" },
        { image: dessert7, description: "커피", price: "₩3000" },
        { image: dessert8, description: "크레이프", price: "₩1000" },
    ]
    const boissons = [
        { image: boisson1, description: "코카콜라", price: "₩1000" },
        { image: boisson2, description: "소주", price: "₩3000" },
        { image: boisson3, description: "오렌지 소다", price: "₩2000" },
        { image: boisson4, description: "아이스티", price: "₩2500" },
        { image: boisson5, description: "물", price: "₩1000" },
        { image: boisson6, description: "샴페인", price: "₩10000" },
        { image: boisson7, description: "세븐업", price: "₩1000" },
        { image: boisson8, description: "선키스트", price: "₩2000" },
    ]

    return (
        <div>
            <Typography sx={{ fontFamily: 'Gowun Batang', fontWeight: '700', transition: "all 0.3s ease-in-out", '&:hover': { cursor: 'pointer', transform: 'scale(1.1)' } }} align='center' mt={2} mb={5} variant='h2' onClick={handleOpen}>카드</Typography>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: isMobile ? '80%' : '50%',
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    overflowY: 'auto',
                    maxHeight: '80%',
                }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        카드
                    </Typography>

                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 2, mt: 2 }}>
                        {[...dishes, ...desserts, ...boissons].map((item, index) => (
                            <Card key={index}>
                                <CardMedia
                                    component="img"
                                    height="140"
                                    image={item.image}
                                    alt={item.description}
                                />
                                <CardContent>
                                    <Typography sx={{ fontFamily: 'Gowun Batang', fontSize: "20px" }}>
                                        {item.description}
                                    </Typography>
                                    <Typography sx={{ fontFamily: 'Gowun Batang', fontWeight: "700" }}>
                                        {item.price}
                                    </Typography>
                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                </Box>
            </Modal>
            <div className='glid-dish'>
                <Swiper

                    slidesPerView={isMobile ? 1 : 3}
                    modules={[Navigation, Autoplay]}
                    spaceBetween={10}
                    centeredSlides={true}
                    loop={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    navigation
                    className="mySwiper">
                    {dishes.map((dish, index) => (
                        <SwiperSlide key={index}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                <img src={dish.image} alt={dish.description} style={{ width: '100%', objectFit: 'contain' }} />
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                                    <Typography sx={{ fontFamily: 'Gowun Batang', fontSize: "20px" }}>{dish.description}</Typography>
                                    <Typography sx={{ fontFamily: 'Gowun Batang', fontWeight: "700" }}>{dish.price}</Typography>
                                </Box>
                            </Box>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className='dessert-dish' style={{ marginTop: '50px' }}>
                <Swiper slidesPerView={isMobile ? 1 : 3}
                    modules={[Navigation, Autoplay]}
                    spaceBetween={10}
                    centeredSlides={true}
                    loop={true}
                    autoplay={{
                        delay: 2900,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    navigation>
                    {desserts.map((dessert, index) => (
                        <SwiperSlide key={index}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                <img src={dessert.image} alt={dessert.description} style={{ width: '100%', objectFit: 'contain' }} />
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                                    <Typography sx={{ fontFamily: 'Gowun Batang', fontSize: "20px" }}>{dessert.description}</Typography>
                                    <Typography sx={{ fontFamily: 'Gowun Batang', fontWeight: "700" }}>{dessert.price}</Typography>
                                </Box>
                            </Box>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className='boissons' style={{ marginTop: '50px' }}>
                <Swiper slidesPerView={isMobile ? 1 : 3}
                    modules={[Navigation, Autoplay]}
                    spaceBetween={10}
                    centeredSlides={true}
                    loop={true}
                    autoplay={{
                        delay: 2950,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    navigation>
                    {boissons.map((boisson, index) => (
                        <SwiperSlide key={index}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                <img src={boisson.image} alt={boisson.description} style={{ width: '100%', objectFit: 'contain' }} />
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                                    <Typography sx={{ fontFamily: 'Gowun Batang', fontSize: "20px" }}>{boisson.description}</Typography>
                                    <Typography sx={{ fontFamily: 'Gowun Batang', fontWeight: "700" }}>{boisson.price}</Typography>
                                </Box>
                            </Box>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}

export default Menus